var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"q-pa-md q-gutter-sm"},[_c('q-tree',{ref:"refHrOrg",attrs:{"nodes":_vm.jsonHrOgr,"node-key":"id","label-key":"name","default-expand-all":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }